import React from "react";

const SignInModal = ({ show, handleClose, switchToSignUp }) => {
  return (
    <div
      className={`modal fade ${show ? "show d-block" : "d-none"}`}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg">
          <div
            className="modal-header brand-header text-white"
            style={{ backgroundColor: "#c69933" }}
          >
            <h5 className="modal-title text-center">Welcome Again</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="you@example.com"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="********"
                />
              </div>
              <button
                type="submit"
                className=" w-100 py-2 text-white rounded-pill "
                style={{
                  border: "2px solid #c69933",
                  backgroundColor: "#c69933",
                }}
              >
                Sign In
              </button>
            </form>
            <div className="text-center mt-4">
              <span>Don't have an account?</span>
              <button
                className=" p-0 ms-1"
                onClick={switchToSignUp}
                style={{
                  color: "#c69933",
                  border: "none",
                  background: "transparent",
                }}
              >
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
